module.exports = __webpack_public_path__ + "static/img/Featured-Freebie-Background-Image.6a1fd89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images/Featured-Freebie-Background-Image.png
// module id = dXap
// module chunks = 44